import { palettes } from '@outbook/colorful';

export const accents = [
  {
    bg: 'bg-slate-500',
    name: 'slate',
    code: palettes.oklch.slate[500]
  },
  {
    bg: 'bg-gray-500',
    name: 'gray',
    code: palettes.oklch.gray[500]
  },
  {
    bg: 'bg-zinc-500',
    name: 'zinc',
    code: palettes.oklch.zinc[500]
  },
  {
    bg: 'bg-neutral-500',
    name: 'neutral',
    code: palettes.oklch.neutral[500]
  },
  {
    bg: 'bg-stone-500',
    name: 'stone',
    code: palettes.oklch.stone[500]
  },
  {
    bg: 'bg-red-500',
    name: 'red',
    code: palettes.oklch.red[500]
  },
  {
    bg: 'bg-orange-500',
    name: 'orange',
    code: palettes.oklch.orange[500]
  },
  {
    bg: 'bg-amber-500',
    name: 'amber',
    code: palettes.oklch.amber[500]
  },
  {
    bg: 'bg-yellow-500',
    name: 'yellow',
    code: palettes.oklch.yellow[500]
  },
  {
    bg: 'bg-lime-500',
    name: 'lime',
    code: palettes.oklch.lime[500]
  },
  {
    bg: 'bg-green-500',
    name: 'green',
    code: palettes.oklch.green[500]
  },
  {
    bg: 'bg-emerald-500',
    name: 'emerald',
    code: palettes.oklch.emerald[500]
  },
  {
    bg: 'bg-teal-500',
    name: 'teal',
    code: palettes.oklch.teal[500]
  },
  {
    bg: 'bg-cyan-500',
    name: 'cyan',
    code: palettes.oklch.cyan[500]
  },
  {
    bg: 'bg-sky-500',
    name: 'sky',
    code: palettes.oklch.sky[500]
  },
  {
    bg: 'bg-blue-500',
    name: 'blue',
    code: palettes.oklch.blue[500]
  },
  {
    bg: 'bg-indigo-500',
    name: 'indigo',
    code: palettes.oklch.indigo[500]
  },
  {
    bg: 'bg-violet-500',
    name: 'violet',
    code: palettes.oklch.violet[500]
  },
  {
    bg: 'bg-purple-500',
    name: 'purple',
    code: palettes.oklch.purple[500]
  },
  {
    bg: 'bg-fuchsia-500',
    name: 'fuchsia',
    code: palettes.oklch.fuchsia[500]
  },
  {
    bg: 'bg-pink-500',
    name: 'pink',
    code: palettes.oklch.pink[500]
  },
  {
    bg: 'bg-rose-500',
    name: 'rose',
    code: palettes.oklch.rose[500]
  },
  {
    bg: 'bg-mauve-500',
    name: 'mauve',
    code: palettes.oklch.mauve[500]
  },
  {
    bg: 'bg-taupe-500',
    name: 'taupe',
    code: palettes.oklch.taupe[500]
  },
  {
    bg: 'bg-mist-500',
    name: 'mist',
    code: palettes.oklch.mist[500]
  },
  {
    bg: 'bg-olive-500',
    name: 'olive',
    code: palettes.oklch.olive[500]
  }
];
